// extracted by mini-css-extract-plugin
export default {"-large":"Qnl4naBIdVwHKkazVf07","iconBox":"e5t3GiBmgExcSvBljJVA"};